/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCards200ResponseInnerReissueOneOf
 */
export interface GetCards200ResponseInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetCards200ResponseInnerReissueOneOf
     */
    'cardType': GetCards200ResponseInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetCards200ResponseInnerReissueOneOf
     */
    'expiredDate': string;
}

export const GetCards200ResponseInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type GetCards200ResponseInnerReissueOneOfCardTypeEnum = typeof GetCards200ResponseInnerReissueOneOfCardTypeEnum[keyof typeof GetCards200ResponseInnerReissueOneOfCardTypeEnum];


